import React from 'react';

interface ComponentProps {}

const RegisterPage: React.FC<ComponentProps> = () => {
  return <>Register</>;
};

export default RegisterPage;
